
import { Component, Prop, Vue, Provide, Inject } from 'vue-property-decorator'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
@Observer
@Component({
  components: {}
})
export default class PageView extends Vue {
  get Pagination() {
    return this.$store.$storeStationery.Pagination
  }
  get body() {
    return {
      typeId: -1,
      commodityName: ''
    }
  }
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
